import React, { type FunctionComponent, type ReactElement } from 'react';
import { TextLabel } from '@wix/wix-base-ui';

import constants from '#packages/constants';
import { workspace } from '#packages/util';

import withCustomDropPanelBehavior from '../hocs/withCustomDropPanelBehavior';

import Button from '../topBarButton/topBarButtonWithTooltip';

const { BUTTONS } = constants.ROOT_COMPS.TOPBAR;

interface UndoButtonProps {
  tooltip?: ReactElement;
  disabled?: boolean;
  onClick: () => void;
  onMouseLeave?: () => void;
  onMouseEnter?: () => void;
}

const UndoButton: FunctionComponent<UndoButtonProps> = (props) => {
  const symbolName = workspace.isNewWorkspaceEnabled()
    ? 'undo_NewWorkspace'
    : 'undo2_v2';

  return (
    <Button
      className="top-bar-button-undo"
      automationId="top-bar-button-undo"
      symbolName={symbolName}
      disabled={props.disabled}
      tooltip={props.tooltip}
      onClick={props.onClick}
      onMouseLeave={props.onMouseLeave}
      onMouseEnter={props.onMouseEnter}
    />
  );
};

UndoButton.defaultProps = {
  tooltip: (
    <TextLabel value="TOPBAR_UNDO_TOOLTIP_TITLE" enableEllipsis={false} />
  ),
};

const ConnectedUndoButton = withCustomDropPanelBehavior(BUTTONS.UNDO)(
  UndoButton,
) as React.ComponentType<UndoButtonProps>;

export default ConnectedUndoButton;
